<template>
    <v-col cols="12" xl="10" class="py-10 px-0">
        <v-row>
            <v-col cols="12" lg="4" class="py-0">
                <b-input
                    to-mutate="pharmacy_groups::pharmacy_group.out_of_hours_contact_name"
                    :label="t('pharmacy-groups::form.label.out_of_hours_contact_name')"
                    :readonly="readOnlyRules"
                    :rules="validationRules.out_of_hours_contact_name"
                    mandatory
                ></b-input>
            </v-col>
            <v-col cols="12" lg="4" class="py-0">
                <b-input
                    to-mutate="pharmacy_groups::pharmacy_group.out_of_hours_contact_phone"
                    :label="t('pharmacy-groups::form.label.out_of_hours_contact_phone')"
                    :readonly="readOnlyRules"
                    :rules="validationRules.out_of_hours_contact_phone"
                    mandatory
                ></b-input>
            </v-col>
            <v-col cols="12" lg="4" class="py-0">
                <b-input
                    to-mutate="pharmacy_groups::pharmacy_group.out_of_hours_contact_fax"
                    :label="t('pharmacy-groups::form.label.out_of_hours_contact_fax')"
                    :readonly="readOnlyRules"
                    :rules="validationRules.out_of_hours_contact_fax"
                ></b-input>
            </v-col>
            <v-col cols="12" lg="4" class="py-0">
                <b-input
                    to-mutate="pharmacy_groups::pharmacy_group.out_of_hours_contact_email"
                    :label="t('pharmacy-groups::form.label.out_of_hours_contact_email')"
                    :readonly="readOnlyRules"
                    :rules="validationRules.out_of_hours_contact_email"
                    mandatory
                ></b-input>
            </v-col>
        </v-row>
    </v-col>
</template>

<script>
export default {
    data() {
        return {
            readOnlyRules: !this.can('api.v1.pharmacy-groups.update') && this.can('api.v1.pharmacy-groups.show'),
            validationRules: {
                out_of_hours_contact_name: [(v) => !!v || t('users::validation.field.required')],
                out_of_hours_contact_phone: [
                    (v) => !!v || t('users::validation.field.required'),
                    this.$root.rules.phone,
                ],
                out_of_hours_contact_fax: [this.$root.rules.fax],
                out_of_hours_contact_email: [
                    (v) => !!v || t('users::validation.field.required'),
                    this.$root.rules.email,
                ],
            },
        };
    },
};
</script>

<style></style>
